import React from 'react';
import LoadingPlaceholderBlock from "../../../../../components/common/LoadingPlaceholderBlock";
import ConversationCsatLoader from "./ConversationCsatLoader";
import PreSaleLoader from "./PreSaleLoader";
import {CSAT} from "../MetricsDetailUtils";
import styles from "../Utilities/Styles.module.css";

const MetricsConversationLoader = ({pageFilter}) => {
    const conversationRow = <div className="conversation-item-container">
        <div className="conversation-item-row">
            <div className={styles.conversationItemInner}>
                <LoadingPlaceholderBlock width={'96px'} height={'18px'} borderRadius={'3px'} backgroundColor={'rgb(239, 234, 229)'} />
                <div className={styles.ml342}>
                    <LoadingPlaceholderBlock width={'245px'} height={'18px'} borderRadius={'3px'} backgroundColor={'rgb(239, 234, 229)'} />
                </div>
            </div>
            <LoadingPlaceholderBlock height={'90px'} borderRadius={'6px'} backgroundColor={'rgb(239, 234, 229)'} />
            <PreSaleLoader />
        </div>
    </div>

    return (
        <div className={styles.conversationLoaderContainer}>
            <div className="md-msg-container">
                {conversationRow}
            </div>
            { pageFilter === CSAT ? <ConversationCsatLoader /> :
                <div className="md-msg-container">
                    {conversationRow}
                </div>
            }
        </div>
    )
}

export { MetricsConversationLoader }